import { render, staticRenderFns } from "./DashboardGridItem.vue?vue&type=template&id=24e8f7c6&scoped=true&"
import script from "./DashboardGridItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardGridItem.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardGridItem.vue?vue&type=style&index=0&id=24e8f7c6&lang=scss&scoped=true&"
import style1 from "./DashboardGridItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8f7c6",
  null
  
)

export default component.exports